import { render } from "./BioDataTable.vue?vue&type=template&id=1aea099e&scoped=true&xmlns%3A=true"
import script from "./BioDataTable.vue?vue&type=script&lang=js"
export * from "./BioDataTable.vue?vue&type=script&lang=js"

import "./BioDataTable.vue?vue&type=style&index=0&id=1aea099e&lang=scss&scoped=true"
import "./BioDataTable.vue?vue&type=style&index=1&id=1aea099e&lang=css"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aea099e"]])

export default __exports__